<!--
 * @Description: 包车路线
 * @Autor: Zhongyu
 * @Date: 2022-01-26 12:01:54
 * @LastEditors: JF
 * @LastEditTime: 2022-02-25 17:10:54
-->
<template>
  <div class="bag-car">
    <div class="bag-car-hander">
      <div class="hander-left">
        <a-icon type="unordered-list" />
        <span>班车路线</span>
      </div>
      <div class="hander-right">
        <div class="form">
          <div class="form-item">
            <label>班线名称:</label>
            <!-- <a-select value="1">
              <a-select-option value="1">易为茂公司</a-select-option>
              <a-select-option value="2">易为茂公司</a-select-option>
            </a-select> -->
            <a-input
              v-model="params.name"
              placeholder="请输入班线名称"
            ></a-input>
          </div>
          <div class="form-item">
            <a-config-provider :auto-insert-space-in-button="false">
              <a-button type="primary" @click="handlerSumbit">查询</a-button>
            </a-config-provider>
          </div>
        </div>
      </div>
    </div>
    <div class="bag-car-table">
      <a-table
        class="default-table"
        :columns="columns"
        :data-source="data"
        :pagination="false"
        :locale="{ emptyText: '暂无数据' }"
        :scroll="{ y: '26.1vw' }"
        :loading="loading"
        row-key="id"
      >
        <span slot="state" slot-scope="text">
          {{ $utils.wayState(text) }}
        </span>
        <span slot="routeNum" slot-scope="text">
          {{ $utils.formatDigital(text) }}
        </span>
        <span slot="mileage" slot-scope="text">
          {{ $utils.formatDigital(text, 2) }}
        </span>
        <span slot="routeBack" slot-scope="text">
          <span v-if="text == 0" class="red">
            {{ $utils.whetherRunder(text) }}
          </span>
          <span v-if="text == 1" class="green">
            {{ $utils.whetherRunder(text) }}
          </span>
        </span>
        <span slot="action" slot-scope="text, record" class="operation-action">
          <span class="operation blue" @click="handleTableDatails(record)">
            <span class="iconfont icon-bianji"></span>
            查看
          </span>
        </span>
      </a-table>
    </div>
    <div class="bag-car-pagination">
      <pagination
        ref="pagination"
        :total="total"
        @change="handlerPaginationChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

const columns = [
  {
    title: "线路名称",
    dataIndex: "name",
    key: "name",
    ellipsis: true
  },
  {
    title: "路线类型",
    dataIndex: "state",
    key: "state",
    ellipsis: true,
    width: "15vw",
    scopedSlots: { customRender: "state" }
  },
  {
    title: "行驶次数",
    dataIndex: "routeNum",
    key: "routeNum",
    ellipsis: true,
    width: "13vw",
    scopedSlots: { customRender: "routeNum" }
  },
  {
    title: "行驶公里数(万公里)",
    dataIndex: "mileage",
    key: "mileage",
    ellipsis: true,
    width: "15vw",
    scopedSlots: { customRender: "mileage" }
  },
  {
    title: "是否返程",
    dataIndex: "routeBack",
    key: "routeBack",
    ellipsis: true,
    width: "8vw",
    scopedSlots: { customRender: "routeBack" }
  },
  {
    title: "操作",
    key: "action",
    width: "8vw",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  components: {
    Pagination
  },
  data() {
    return {
      data: [],
      columns,
      params: {
        num: 10,
        page: 1,
        type: 1,
        name: "",
        ownerId: this.$Cookies.get("ownerId")
          ? this.$Cookies.get("ownerId")
          : -1
      },
      total: 0,
      loading: false
    };
  },
  mounted() {
    this.getShiftLine();
  },
  methods: {
    handleTableDatails(record) {
      this.$router.push(`/route-details?id=${record.id}`);
    },
    getShiftLine() {
      let params = { ...this.params };
      this.loading = true;
      this.$api.list
        .getShiftLine(params)
        .then(res => {
          this.data = res.data.list;
          this.total = res.data.total;
        })
        .catch(err => {
          this.$message.error(err?.msg, 1);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handlerSumbit() {
      this.params.page = 1;
      this.$refs.pagination.setData(this.params.page, this.params.num);
      this.getShiftLine();
    },
    handlerPaginationChange(page, size) {
      this.params.page = page;
      this.params.num = size;
      this.getShiftLine();
    }
  }
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
